import React from 'react';
import PropertyCard from './PropertyCard';
import Pagination from '../../../components/ui/Pagination';
import Icon from '../../../components/AppIcon';

const PropertyGrid = ({
  properties,
  loading,
  favoritePropertyIds,
  currentPage = 1,
  totalPages = 1,
  totalResults = 0,
  resultsPerPage = 24,
  layout = 'grid',
  onPageChange,
}) => {
  const isList = layout === 'list';
  const listClass = isList
    ? 'flex flex-col gap-3'
    : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5';

  const SkeletonCard = () => (
    <div
      className={`bg-white border border-slate-200 overflow-hidden shadow-sm animate-pulse ${
        isList ? 'flex h-[120px] sm:h-[128px] rounded-xl' : 'rounded-2xl'
      }`}
    >
      <div className={isList ? 'w-[132px] sm:w-[168px] h-full bg-slate-100 flex-shrink-0' : 'aspect-[4/3] bg-slate-100'} />
      <div className="p-4 space-y-3 flex-1">
        <div className="h-5 bg-slate-100 rounded w-1/2" />
        <div className="h-4 bg-slate-100 rounded w-full" />
        <div className="h-4 bg-slate-100 rounded w-2/3" />
      </div>
    </div>
  );

  if (loading && !properties?.length) {
    return (
      <div className={listClass}>
        {Array.from({ length: isList ? 6 : 8 }).map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  if (!properties?.length && !loading) {
    return (
      <div className="text-center py-16 rounded-2xl border border-dashed border-slate-200 bg-white">
        <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="SearchX" size={28} className="text-slate-400" />
        </div>
        <h3 className="text-lg font-semibold text-slate-900 mb-2">No matching properties</h3>
        <p className="text-slate-500 max-w-md mx-auto">
          Adjust filters or clear them to see more results across Uganda.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className={listClass}>
        {properties?.map((property) => (
          <PropertyCard
            key={property?.id}
            property={property}
            variant={isList ? 'list' : 'grid'}
            isFavorite={favoritePropertyIds?.includes(property?.id)}
          />
        ))}
      </div>

      {totalPages > 1 && !loading && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
          resultsPerPage={resultsPerPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default PropertyGrid;
